import { TimeBlock, TimeBlockInput, RecurringBlockResult } from "../../model/timeblock/TimeBlock";
import { RecurrenceInput } from "../../model/appointment/Appointment";
import i18n from "../../i18n";

const API_URL = process.env.REACT_APP_CALENDAR_SERVICE_BASE_URL || "";

async function gqlPost<T>(token: string, query: string, variables?: object): Promise<T> {
    const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, "Accept-Language": i18n.language || "pt" },
        body: JSON.stringify({ query, variables }),
    });
    const json = await res.json();
    if (json.errors) {
        throw new Error(json.errors.map((e: { message: string }) => e.message).join(", "));
    }
    return json.data as T;
}

const FIELDS = `id businessId teamMemberId startTime endTime title seriesId`;

export async function getTimeBlocksByBusinessAndRange(
    businessId: string,
    start: string,
    end: string,
    token: string
): Promise<TimeBlock[]> {
    const data = await gqlPost<{ getTimeBlocksByBusinessAndRange: TimeBlock[] | null }>(
        token,
        `query getTimeBlocksByBusinessAndRange($businessId: ID!, $start: String!, $end: String!) {
            getTimeBlocksByBusinessAndRange(businessId: $businessId, start: $start, end: $end) { ${FIELDS} }
        }`,
        { businessId, start, end }
    );
    return data.getTimeBlocksByBusinessAndRange ?? [];
}

export async function saveTimeBlock(input: TimeBlockInput, token: string): Promise<TimeBlock> {
    const data = await gqlPost<{ saveTimeBlock: TimeBlock }>(
        token,
        `mutation saveTimeBlock($input: TimeBlockInput!) {
            saveTimeBlock(input: $input) { ${FIELDS} }
        }`,
        { input }
    );
    return data.saveTimeBlock;
}

export async function createRecurringTimeBlock(
    input: TimeBlockInput,
    recurrence: RecurrenceInput,
    token: string
): Promise<RecurringBlockResult> {
    const data = await gqlPost<{ createRecurringTimeBlock: RecurringBlockResult }>(
        token,
        `mutation createRecurringTimeBlock($input: TimeBlockInput!, $recurrence: RecurrenceInput!) {
            createRecurringTimeBlock(input: $input, recurrence: $recurrence) {
                created { ${FIELDS} }
                skipped
            }
        }`,
        { input, recurrence }
    );
    return data.createRecurringTimeBlock;
}

export async function deleteTimeBlock(id: string, token: string): Promise<boolean> {
    const data = await gqlPost<{ deleteTimeBlock: boolean }>(
        token,
        `mutation deleteTimeBlock($id: ID!) { deleteTimeBlock(id: $id) }`,
        { id }
    );
    return !!data.deleteTimeBlock;
}

export async function deleteTimeBlockSeries(seriesId: string, token: string): Promise<boolean> {
    const data = await gqlPost<{ deleteTimeBlockSeries: boolean }>(
        token,
        `mutation deleteTimeBlockSeries($seriesId: ID!) { deleteTimeBlockSeries(seriesId: $seriesId) }`,
        { seriesId }
    );
    return !!data.deleteTimeBlockSeries;
}
